module.exports = __webpack_public_path__ + "static/media/b2180707.jpg";